import React, { useEffect, useState } from 'react';
import sayanPhoto from '../../Assets/Profile pics/SayanSir2.0.jpeg';
import chandrimaPhoto from '../../Assets/Profile pics/Chandrimamaam.jpeg';
import principalPhoto from '../../Assets/Profile pics/principalsir.jpeg';
import mrsSenPhoto from '../../Assets/Profile pics/MrsM.sen.jpeg';

import './Section3.css';

import AOS from 'aos';
import 'aos/dist/aos.css';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const cardDetails = [
  {
    id: "sayan",
    role: "Managing Director",
    title: "Sayan Sen",
    photo: sayanPhoto,
    photoAlt: "Sayan Da",
    experience: "Industry: 7+ yrs; Teaching: 15+ yrs; Counselling: 14+ yrs; Marketing: 16+ yrs",
    qualification: "Electronic & Robotics Engineer; A+, N+, CCNA, CCNP, MCSA, MCSE",
    passion: "Automation, research, development, and technical education",
    about: "Projects: automation, sensors, PLC/TMT controls, DG panels, RPM counters, testing, and R&D.",
  },
  {
    id: "chandrima",
    role: "General Manager & Legal Consultant",
    title: "Chandrima Sen",
    photo: chandrimaPhoto,
    photoAlt: "Chandrima Di",
    experience: "7+ years",
    qualification: "BA (Hons); LLB; Professional advocate",
    passion: "Assistant CFO; tax and criminal law",
    about: "Legal and finance leadership with 7+ years of experience.",
  },
  {
    id: "principalsir",
    role: "Academic Principal & CFO",
    title: "Mr. S.K. Sen",
    photo: principalPhoto,
    photoAlt: "Mr. S.K. Sen",
    experience: "Academic and management: 50+ yrs; CFO: 14 yrs",
    qualification: "Mechanical Engineer; Former Govt. ITI professor",
    passion: "Academic management and institutional leadership",
    about: "Leads academic management and institutional operations.",
  },
  {
    id: "MrsM.sen",
    role: "CEO",
    title: "Mrs. M. Sen",
    photo: mrsSenPhoto,
    photoAlt: "Mrs. M. Sen",
    experience: "14+ years",
    qualification: "Business founder; Trustee",
    passion: "Business and management leadership",
    about: "CEO, founder, management head, and trustee with 14+ years of experience.",
  },
];

export default function Section3() {
  const [openCard, setOpenCard] = useState(null);

  useEffect(() => {
    AOS.init({
      duration: 650,
      easing: "ease-out-cubic",
      once: true,
      offset: 70,
    });

    AOS.refresh();
  }, []);

  return (
    <div className="section3_container">

      <div
        className="upper_sec3"
        data-aos="fade-up"
        data-aos-duration="600"
        data-aos-delay="50"
        data-aos-once="true"
      >
        <p
          className="Motto_line"
          data-aos="fade-down"
          data-aos-duration="550"
          data-aos-delay="100"
          data-aos-once="true"
        >
          We comes For You
        </p>

        <h2
          className="sec3_title"
          data-aos="fade-up"
          data-aos-duration="650"
          data-aos-delay="150"
          data-aos-once="true"
        >
          Managing Heads of the Institution
        </h2>
      </div>


      <div className="lower_sec3">

        <section
          className="cards-container"
          data-aos="fade-up"
          data-aos-duration="650"
          data-aos-delay="200"
          data-aos-once="true"
        >

          <div className="cards-wrapper">

            {cardDetails.map((card, index) => {
              const isOpen = openCard === card.id;
              const drawerId = `section3-about-${card.id}`;

              return (
                <article
                  key={card.id}
                  className="card_blnk"
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay={250 + index * 100}
                  data-aos-once="true"
                >
                  <h3 className="section3-card-role">{card.role}</h3>
                  <img className="section3-card-logo" src={card.photo} alt={card.photoAlt} />
                  <h4 className="section3-card-title">{card.title}</h4>

                  <dl className="section3-card-details">
                    <div><dt>Experience</dt><dd>{card.experience}</dd></div>
                    <div><dt>Qualification</dt><dd>{card.qualification}</dd></div>
                    <div><dt>Passion</dt><dd>{card.passion}</dd></div>
                  </dl>

                  <button
                    type="button"
                    id={`${drawerId}-toggle`}
                    className="section3-about-toggle"
                    aria-expanded={isOpen}
                    aria-controls={drawerId}
                    aria-label={`About ${card.title}`}
                    onClick={() => setOpenCard(isOpen ? null : card.id)}
                  >
                    <span>About</span>
                    <span className="section3-about-chevron" aria-hidden="true">&#8964;</span>
                  </button>
                  <div
                    id={drawerId}
                    className={`section3-about-drawer${isOpen ? " is-open" : ""}`}
                    role="region"
                    aria-labelledby={`${drawerId}-toggle`}
                    aria-hidden={!isOpen}
                  >
                    <div className="section3-about-inner">
                      <p>{card.about}</p>
                    </div>
                  </div>

                  <button type="button" className="join-btn">Join Now</button>
                </article>
              );
            })}

          </div>

        </section>

      </div>

    </div>
  );
}
